
import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import NewsletterForm from "./components/newsletter-form";
import Infinite from "./components/infinite";

import DeviceManager from "./utils/device-manager";
import ScrollTop from "./utils/back-to-top";

import ReferencesSlider from "./components/references-slider";
import BreedingSlider from "./components/breeding-slider";
import SocialShare from "./utils/social-share";

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// Handheld menu
		// const handheldMenu = new HandheldMenu();

		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// News slider component
		const $newsSliders = $(".news-slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// // Partners slider component
		// const $partnersSliders = $(".partners-slider");
		// if ($partnersSliders.length) {
		// 	$partnersSliders.each(function (index, el) {
		// 		const partnerSlider = new PartnersSlider($(el));
		// 	});
		// }

		// Reviews slider component
		const $reviewsSlider = $(".reviews__slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// BU Product slider component
		const $buProductSlider = $(".bu-products-slider");
		if ($buProductSlider.length) {
			$buProductSlider.each(function (index, el) {
				const buProductSlider = new BUProductSlider($(el));
			});
		}

		// Image with hotspots component
		const $imagesWithHotspots = $(".image-hotspots-selector");
		if ($imagesWithHotspots.length) {
			$imagesWithHotspots.each(function (index, el) {
				const imageWithHotspots = new ImageHotspotsSelector($(el));
			});
		}

		// Image with hotspots component
		const $jobOffersList = $(".archive-offers_list");
		const $jobOffersSearchForm = $(".archive-offers_searchform");
		const $jobOffersCountryFilter = $(".archive-offers_country-filter");
		if ($jobOffersList.length && $jobOffersSearchForm.length && $jobOffersCountryFilter.length) {
			const jobOffersList = new JobOfferList($jobOffersList, $jobOffersSearchForm, $jobOffersCountryFilter);
		}

		// Locations map component
		const $locationsMapsElements = $(".location-map-placeholder");
		if ($locationsMapsElements.length) {
			$locationsMapsElements.each(function (index, el) {
				const locationsMap = new LocationsMap(el);
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Timeline component
		const $timelineElements = $(".timeline");
		if ($timelineElements.length) {
			$timelineElements.each(function (index, el) {
				const $el = $(el);

				// $el.imagesLoaded(function() {
				const timeline = new Timeline($el);
				// });
			});
		}
		// Home page references slider component
		const $front_page_slider = $(".references-slider_container");
		if ($front_page_slider.length) {
			$front_page_slider.each(function (index, el) {
				const frontPageSlider = new ReferencesSlider($(el));
			});
		}

		// Home page breeding slider component
		const $front_page_slider_breeding = $(".references-slider_container");
		if ($front_page_slider_breeding.length) {
			$front_page_slider_breeding.each(function (index, el) {
				const frontPageSliderBreeding = new BreedingSlider($(el));
			});
		}


		// Home page partners slider component
		const $front_page_slider_partners = $(".partner-logo_section");
		if ($front_page_slider_partners.length) {
			$front_page_slider_partners.each(function (index, el) {
				const frontPageSliderPartners = new PartnersSlider($(el));
			});
		}

		// Social share popup
		const socialShare = document.querySelector('.share-button-wrapper');
		if (socialShare) {
			const socialSharesecond = new SocialShare(socialShare);
		};


		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			let tarteaucitronLang = '';
			switch(document.documentElement.lang) {
				case 'fr-FR':
				tarteaucitronLang = 'fr';
				break;
				case 'en-US':
				tarteaucitronLang = 'en';
				break;

				default:
					tarteaucitronLang = 'fr';
			}

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		$(".mediatheque-filters li.cat-has-children").on("mouseenter", function (e) {
			const $target = $(e.currentTarget);
			const $children = $target.find("> .children");

			if ($children.length) {
				$(".mediatheque-filters").css("padding-bottom", $children.outerHeight());
			}
		});
		$(".mediatheque-filters li.cat-has-children").on("mouseleave", function (e) {
			$(".mediatheque-filters").css("padding-bottom", 0);
		});

		if (window.matchMedia("(max-width: 767px)").matches) {
			$(".mediatheque-filters .cat-has-children > a").click(function () {
				event.preventDefault();

				var $this = $(this);
				var $catItem = $this.parent(".cat-has-children");

				$catItem.toggleClass("opened");
			});
		}

		// Séparation des h1 pour couleurs personnalisées automatiques.
		$('h1').each(function() {
			let text = $(this).text().trim().split(' ');
			
            if(text.length < 2) {
				return;
            } else if (text.length > 6) {
				$(this).addClass('remove-decoration');
			}
		
			text[0] = '<span class="firstWord">' + text[0] + '</span>';
		
			$(this).html(text.join(' '));
		});		

		// Wrap les h2 décorés d'un container
		$('.heading--h2.decorated').each(function() {
			let tag = $(this).wrap("<div class='decoration-container'></div>");
			if($(this).parents('.newsletter').length == 0 ) {
				let clone = $(this).clone().insertAfter(this);
				clone.contents().unwrap().wrapAll('<div class="background-title"></div>');
			}
			$(this).wrap("<span class='container-title'></span>");
		});

		// Filtre des chevaux page catalogue
		$('select').change(function() {
			changeList();
		});


		function changeList() {
			var $horses = $(".item-latest-horse");
			if($horses.length) {
				var activeFilters = [$("#sex").val(), $("#year").val(), $('#category').val()].filter(function(value) {
					return value !== '0';
				});
				if(activeFilters.length) {
					$horses.hide().filter('.' + activeFilters.join('.')).show();
				}
				else {
					$horses.show();
				}
			}
		}

		// Vidéo au click page cheval
		jQuery(document).ready(function($) {

			$('.video-single-thumbnail_gallery').click(function(e) {
				e.preventDefault();
				var $idThumb = $(this).attr('href');
				var $mainImg = $($idThumb);
				$('.video_main-container > div').removeClass('is-selected');
				$mainImg.addClass('is-selected');
			});
		
		})
		
	});
})(jQuery);
